import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.function.name";
import { __awaiter, __generator, __read, __spread } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: function state() {
    return {
      activityList: {
        list: [],
        loaded: false,
        requesting: false
      },
      activityDetailMap: {}
    };
  },
  mutations: {
    concatList: function concatList(state, list) {
      var _a;

      (_a = state.activityList.list).push.apply(_a, __spread(list));
    },
    setListLoaded: function setListLoaded(state, loaded) {
      state.activityList.loaded = loaded;
    },
    setListReq: function setListReq(state, req) {
      state.activityList.requesting = req;
    },
    setActivityDetailMap: function setActivityDetailMap(state, _a) {
      var activityId = _a.activityId,
          detail = _a.detail;
      Vue.set(state.activityDetailMap, String(activityId), detail);
    }
  },
  actions: {
    /**
     * 获取同城活动列表
     * @param {} offset
     * @param {} count
     * @param {} forceUpdate
     */
    getActivityList: function getActivityList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, list, end, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              wrap = state.activityList;

              if (wrap.requesting || wrap.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                wrap.loaded = false;
                wrap.list = [];
              }

              list = wrap.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setListReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/city_activity/list', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatList', rdata.data);

                if (rdata.data.length < count) {
                  commit('setListLoaded', true);
                }
              }

              commit('setListReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取同城活动详情
     * @param {} activityId
     * @param {} forceUpdate
     */
    getActivityDetail: function getActivityDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (state.activityDetailMap[activityId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/city_activity/detail', {
                params: {
                  id: activityId
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setActivityDetailMap', {
                  activityId: activityId,
                  detail: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 提交同城活动创建申请
     */
    createActivity: function createActivity(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var cover = _b.cover,
          name = _b.name,
          start_date = _b.start_date,
          end_date = _b.end_date,
          qr_code = _b.qr_code,
          description = _b.description;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/city_activity/create', {
                cover: cover,
                name: name,
                start_date: start_date,
                end_date: end_date,
                qr_code: qr_code,
                description: description
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;